<template>
  <div :class="`reSuccess ${$store.state.isMobile ? 'reSuccess_mobile' : ''}`">
    <!-- h5 -->
    <!-- {{ $store.state.isMobile }} -->
    <div v-if="$store.state.isMobile">
      
      <mobileBack :style="`background: #fff;${$route.query.orderType == 2 ? 'padding-left: 0.25rem' : 'padding-left: 0.05rem'}`"></mobileBack>
      <img v-if="pageType" :src="require(pageType ? '../../assets/hx.png' : '../../assets/re_success.png')">
      <div class="reSuccessTopWarp">
        <div class="reSuccessWbs" v-if="!pageType">
          <div class="text" v-if="reData.auditState != 0 && reData.auditState != 2">
            <div>您已预约成功!</div>
            <!-- {{ reData}} -->
            <div class="resText">
              入场时请携带身份证件或者二维码进行验票
            </div>
          </div>
          <div class="text" v-else>
           
              <div>{{reData.auditState == 0 ? '审核中' : '未通过审核'}}</div>
           
          </div>
          <div class="text textLine" v-if=" (status != 1)">
            
            <div>{{status == 2 ? '已使用' :status == 3 ? '已取消':"已过期"}}</div>
          </div>
          <!-- <div v-else class="text textLine">
            <div>{{orderStatus[reData.orderStatus]}}</div>
          </div> -->
        </div>
        <!-- {{ status }}
        {{ orderType }} -->
        <div class="itemCard" v-if="reData.orderType == 1">
          <div class="reTime" style="margin-bottom: 0.2rem">场馆名称:<span>{{t_name}}</span></div>
          <div class="reTime" style="margin-bottom: 0.2rem" v-if="personals.length && personals[0].orgName">团队名称:<span>{{personals[0].orgName}}</span></div>
          <div class="reTime">预约时间:<span>{{reData.bookingDate}}&nbsp;{{reData.timeRange}}</span></div>
          <div v-if="status==1&&reData.auditState != 0 && reData.auditState != 2">
            <div class="baseLine"></div>
            <div class="dateNow" v-if="qrCodeUseTime > 0 && !pageType">二维码有效时间：{{qrCodeUseTime}}s</div>
            <div class="dateNow" v-if="qrCodeUseTime <= 0 && !pageType" @click="reloadQrCode">刷新</div>
            <div id="qrcode" ref="qrcode" :class="qrCodeUseTime == 0 ? 'qrCodeTimeOut' : ''" v-show="!pageType"></div>
            <div :class="`buttonNormalContain ${qrCodeUseTime == 0 ? 'timeOut' : ''}`" v-if="$store.state.isMobile && !pageType">{{qrCodeUseTime > 0 ? '待验票' : '已过期'}}</div>
            <!-- {{ reData }} -->
          </div>
          <div v-if="status!=1&&reData.auditState != 0 && reData.auditState != 2">
            <div class="baseLine"></div>
            <div id="qrcode" ref="qrcode" :class="'qrCodeTimeOut'" v-show="!pageType"></div>
            <div :class="`buttonNormalContain timeOut`" v-if="$store.state.isMobile && !pageType">{{'已过期'}}</div>
          </div>
        </div>
      </div>
      <personalCard v-for="(item, index) in personals" :key="item.card">
        <!-- <div slot="left" :class="`leftName ${item.personType == 3 ? 'childLeft' : ''}`">{{item.personName}}</div> -->
        <div slot="right" class="rightContent" v-if="item.personType != 3">
          <div class="cardIndex">{{index + 1}}</div>
          <div class="detail">
            <span class="title">姓<span>名</span>:</span>
            <span class="name">{{item.personName}}</span>
          </div>
          <div class="detail">
            <span class="title">证件类型</span>
            <!-- {{ item.cardType - 1 }}
            {{ cardTypes }} -->
            <span class="name">{{cardTypes[item.cardType - 1]}}</span>
          </div>
          <div class="detail">
            <span class="title">证件号码</span>
            <span class="name">{{item.cardNum}}</span>
          </div>
          <div class="detail">
            <span class="title">联系电话</span>
            <span class="name">{{item.phone}}</span>
          </div>
          <div class="detail" v-if="reData.belongNum && !fillChildrenInfo && !index">
            <span class="title">{{reData.orderType == 2 ? '携带儿童' : '团队人数'}}</span>
            <span class="name">{{reData.belongNum}}名</span>
          </div>
          <div class="showErCode" @click="showErCode(item)" v-if="isFid && reData.orderType == 2">查看核销码</div>
        </div>
        <div slot="right" class="rightContent" v-else>
          <div class="cardIndex">{{index + 1}}</div>
          <div class="detail">
            <span class="title">姓<span>名</span>:</span>
            <span class="name">{{item.personName}}</span>
          </div>
          <div class="detail">
            <span class="title">年龄</span>
            <span class="name">{{item.age}}</span>
          </div>
          <div class="detail" v-if="item.cardNum">
            <span class="title">证件号码</span>
            <span class="name">{{item.cardNum}}</span>
          </div>
          <div class="detail">
            <span class="title">性别</span>
            <span class="name">{{item.gender == 1 ? '男' : '女'}}</span>
          </div>
          <div class="showErCode" @click="showErCode(item)" v-if="isFid && reData.orderType == 2">查看核销码</div>
        </div>
      </personalCard>
      <div class="personalErCode" v-if="showPersonalErCode">
        <mobileBack @backOtherClick="showPersonalErCode=false" :otherClick="true"></mobileBack>
        <div class="baseLine"></div>
        <div class="reTime" style="margin-left: 0.7rem">预约时间：{{reData.bookingDate}}&nbsp;{{reData.timeRange}}</div>
        <div style="font-size: 0.45rem; margin: 0.3rem 0">核销人：{{personalErCodeInfo.personName}}</div>
        <div class="dateNow" v-if="qrCodeUseTime > 0 && !pageType&&status==1">二维码有效时间：{{qrCodeUseTime}}s</div>
        <div class="dateNow" v-if="qrCodeUseTime <= 0 && !pageType&&status==1" @click="reloadQrCode">二维码已过期，请刷新</div>
        <div id="qrcode" ref="qrcode" :class="qrCodeUseTime == 0 ? 'qrCodeTimeOut' : ''" v-show="!pageType&&status==1"></div>
        <div :class="`buttonConfirm ${qrCodeUseTime == 0 ? 'timeOut' : ''}`" v-if="$store.state.isMobile && !pageType&&status==1">{{qrCodeUseTime > 0 ? '待核销' : '已过期'}}</div>
        <!--  -->
        <div v-if="status!=1">
          <div class="dateNow" v-if="!pageType">二维码已过期</div>
        <div id="qrcode" ref="qrcode" :class="'qrCodeTimeOut'" v-if="!pageType"></div>
        <div :class="`buttonConfirm timeOut`" v-if="!pageType">{{'已过期'}}</div>
        </div>
        
      </div>
      <h5Bottom></h5Bottom>
    </div>
    <!-- pc -->
    <div v-else>
      <topBanner></topBanner>
      <div class="pcBg"></div>
      <div class="pcContent">
        <div class="pcToIndex" @click="toBack" style="margin-bottom: 20px;">返回</div>
        <!-- <img src="../../assets/ticket/pc_re_s.png"> -->
        <div class="reSuccessWbs">
          <img src="../../assets/ticket/re_successLeft.png" alt="" class="left">
          <img src="../../assets/ticket/re_successRight.png" alt="" class="right">
          <!-- 江西书画院 -->
          
          <div class="text" v-if="reData.auditState != 0 && reData.auditState != 2">
           
            <div>您已预约成功!</div>
            <div class="resText">
              <div>入场时请携带身份证件或者二维码进行验票</div>
              二维码须在移动端“我的订单”获取
            </div>
          </div>
          <div class="text textLine" v-else>
            <div>{{reData.auditState == 0 ? '审核中' : '未通过审核'}}</div>
          </div>
          <div class="qrcodeWarp" v-if="reData.auditState != 0 && reData.auditState != 2">
            <!-- <img :src="erCode"> -->
            <div id="qrcode2" ref="qrcode2"></div>
            <div class="erCodeText">扫码前往移动端</div>
          </div>
        </div>
        <div class="pcItemCard">
       
          <div class="itemTitle" v-if="!$store.state.isMobile">预约信息</div>
          <div class="pc">
            <div class="reTime" style="margin-bottom: 20px">场馆名称<span>{{t_name}}</span></div>
            <div class="reTime">预约时间<span>{{reData.bookingDate}}&nbsp;（{{reData.timeRange}}）</span></div>
            <div class="line3">
              <div class="personals">
                <personalCard v-for="(item, index) in personals" :key="item.card" v-show="!$store.state.isMobile">
                  <div slot="left" class="leftName">{{item.personName}}</div>
                  <div slot="right" class="rightContent" v-if="item.personType != 3">
                    <div class="detail">
                      <span class="title">证件类型</span>
                      <span class="name">{{cardTypes[item.cardType - 1]}}</span>
                    </div>
                    <div class="detail">
                      <span class="title">证件号码</span>
                      <span class="name">{{item.cardNum}}</span>
                    </div>
                    <div class="detail">
                      <span class="title">联系电话</span>
                      <span class="name">{{item.phone}}</span>
                    </div>
                    <div class="detail" v-if="reData.belongNum && !fillChildrenInfo && !index">
                      <span class="title">{{reData.orderType == 2 ? '携带儿童' : '团队人数'}}</span>
                      <span class="name">{{reData.belongNum}}名</span>
                    </div>
                  </div>
                  <div slot="right" class="rightContent" v-else>
                    <div class="detail">
                      <span class="title">年龄</span>
                      <span class="name">{{item.age}}</span>
                    </div>
                    <div class="detail" v-if="item.cardNum">
                      <span class="title">证件号码</span>
                      <span class="name">{{item.cardNum}}</span>
                    </div>
                    <div class="detail">
                      <span class="title">性别</span>
                      <span class="name">{{item.gender == 1 ? '男' : '女'}}</span>
                    </div>
                  </div>
                </personalCard>
              </div>
            </div>
          </div>
        </div>
        <div class="button3" @click="toPersonalCenter">个人中心</div>
      </div>
    </div>
  </div>
</template>

<script>
import personalCard from '../../components/common/personalCard'
import topBanner from '../../components/common/topBanner'
import QRCode from 'qrcodejs2'
import mobileBack from '../../components/common/mobileBack'
import h5Bottom from '../../components/common/h5Bottom.vue'

var qrcode, qrCodeTime
export default {
  data() {
    return {
      reData: {
        date: '2021-04-14',
        time: '9:00 - 11:00',
      },
      nowData: {},
      erCode: '',
      personals: [],
      qrCodeUseTime: 5,
      cardTypes: ['身份证', '护照(Passport)','港澳居民来往内地通行证','','台胞证', '军官证', '外国人永居证',],
      pageType: '',
      t_name: '',
      isFid: true,
      showPersonalErCode: false,
      personalErCodeInfo: {},
      fillChildrenInfo: false,
      status:1
    };
  },

  components: {personalCard, topBanner, mobileBack, h5Bottom},

  methods: {
    // 返回
    toBack() {
      history.go(-1)
    },

    // 去个人中心
    toPersonalCenter() {
      this.$router.replace(`/ticket/personalCenter?museumCode=${this.$route.query.museumCode}${this.$route.query.id ? `&id=${this.$route.query.id}` : ''}${this.$route.query.code ? `&code=${this.$route.query.code}` : ''}`)
    },

    // 查看个人核销码
    showErCode(item) {
      this.showPersonalErCode = true
      this.personalErCodeInfo = item
      clearInterval(qrCodeTime)
      this.creatQrCode(item.id)
    },
    
    toIndex() {
      this.$router.replace(`/ticket/home?museumCode=${this.$route.query.museumCode}${this.$route.query.id ? `&id=${this.$route.query.id}` : ''}`)
    },

    getOrderDetail(id) {
      this.$ajax(`/api/ticket/front/order/detail?ticketOrderId=${id}`).then((res) => {
        this.t_name = res.data.ticketInfo.ticketName
        this.fillChildrenInfo = res.data.ticketInfo.fillChildrenInfo
        this.personals = res.data.peoples || []
        console.log(this.personals)
        this.reData = res.data.ticketOrder
        console.log( this.reData)
        this.reData.timeRange = res.data.ticketOrder.timeRange.replace(':00-', '-').substring(0,11)
        // 个人预约的pc端
        // this.reData.orderStatus=this.personals[0].orderStatus?this.personals[0].orderStatus:1
        if (!(!this.isFid || this.reData.orderType == 1) && !this.$store.state.isMobile) {
          this.$nextTick(() =>{
            this.creatQrCode()
          })
        }
        if (!(!this.isFid || this.reData.orderType == 1)) return
        if (this.reData.orderType == 1 && this.isFid) {
          this.personalErCodeInfo.id = this.personals.find((item) =>{return !item.belongId}).id
        }
        this.$nextTick(() =>{
          this.creatQrCode()
        })
        console.log(' this.reData')
        console.log( this.reData)

      })
    },

    creatQrCode() {
      if (this.$store.state.isMobile) { //h5端生成核销二维码
        this.$ajax(`/api/ticket/front/order/encrypt-info?orderId=${this.$route.query.orderId}${this.personalErCodeInfo.id ? `&peopleId=${this.personalErCodeInfo.id}` : ''}`).then((res) => {
          this.starTime()
          let text = `${location.origin}${location.pathname}#/ticket/writeOffPersonal?museumCode=${this.$route.query.museumCode}&encryptInfo=${res.data}`;
          qrcode = new QRCode(this.$refs.qrcode, {
            text: text, //页面地址 ,如果页面需要参数传递请注意哈希模式#
            width: 200,
            height: 200,
            colorDark: '#000000',
            colorLight: '#ffffff',
            correctLevel: QRCode.CorrectLevel.H,
          })
        })
      } else { //pc端生成扫码移动端的按钮
        let text = `${location.origin}${location.pathname}#/ticket/home?museumCode=${this.$route.query.museumCode}${this.$route.query.code ? `&code=${this.$route.query.code}` : ''}${this.$route.query.id ? `&id=${this.$route.query.id}` : ''}`;
        qrcode = new QRCode(this.$refs.qrcode2, {
          text: text, //页面地址 ,如果页面需要参数传递请注意哈希模式#
          width: 200,
          height: 200,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: QRCode.CorrectLevel.H,
        })
      }
    },

    starTime() {
      this.qrCodeUseTime = 120
      qrCodeTime = setInterval(() => {
        this.qrCodeUseTime --
      }, 1000)
    },

    reloadQrCode() {
      this.$nextTick(() =>{
        this.$refs.qrcode.innerHTML = ''
        this.creatQrCode()
      })
    },

    getOrderDetailByWrite(id) {
      this.$ajax(`/api/ticket/front/order/write-off-detail?ticketOrderId=${id}&phone=${this.$store.state.writePhone}&museumCode=${this.$route.query.museumCode}`).then((res) => {
        this.t_name = res.data.ticketInfo.ticketName
        this.fillChildrenInfo = res.data.ticketInfo.fillChildrenInfo
        this.personals = res.data.peoples
        this.reData = res.data.ticketOrder
        this.reData.timeRange = res.data.ticketOrder.timeRange.replace(':00-', '-').substring(0,11)
      })
    }
  },

  created() {
    this.isFid = !isNaN(Number(this.$route.query.museumCode)) ? true : false
    this.$route.query.resType ? this.pageType  = this.$route.query.resType : ''
    this.status= this.$route.query.orderStatus?this.$route.query.orderStatus:1
    let date = new Date()
    this.nowData.date = date.getMonth() + 1 + '月' + date.getDate() + '日'
    let h = date.getHours();
    h = h < 10 ? '0' + h : h;
    let min = date.getMinutes();
    min = min < 10 ? '0' + min : min;
    let s = date.getSeconds();
    s = s < 10 ? '0' + s : s;
    this.nowData.time = `${h}:${min}`
    this.erCode = require('../../assets/erCode.png')
    console.log('this.status')
    console.log(this.status)
    this.pageType ? this.getOrderDetailByWrite(this.$route.query.orderId) : this.getOrderDetail(this.$route.query.orderId)
  },

  mounted() {
    // if (this.pageType) return
    // this.$nextTick(() =>{
    //   this.creatQrCode()
    // })
    // console.log(this.$store.state.isMobile)
  },

  computed: {
  
  },

  watch: {
    qrCodeUseTime(val) {
      if (val == 0) {
        clearInterval(qrCodeTime)
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .reSuccess{
    margin-bottom: 1rem;
    // img{
    //   padding: 1rem 0.5rem 0 0.5rem;
    //   width: 9rem;
    // }
    .reTime{
      font-size: 0.45rem;
      font-weight: 500;
      display: flex;
      align-items: center;
      span{
        font-size: 0.42rem;
        font-weight: normal;
        margin-left: 0.3rem;
      }
    }
    .dateNow{
      font-size: 0.65rem;
      font-weight: 500;
      display: flex;
      align-items: center;
      justify-content: center;
      span{
        font-size: 0.55rem;
        font-weight: normal;
        margin-left: 0.9rem;
        font-weight: 500;
      }
    }
    .detail{
      .title{
        width: 1.7rem;
        display: inline-block;
        margin-right: 0.6rem;
      }
    }

    .itemCard{
      #qrcode{
        width: 6rem;
        height: 6rem;
        padding-top: 0.5rem;
        margin: auto;
        img{
          width: 100%;
          height: 100%;
        }
      }
      .qrCodeTimeOut{
        opacity: 0.5
      }
    }
    .buttonConfirm{
      width: 6rem;
    }
    .timeOut{
      background-color: #eee;
      color: #333;
    }
    .showErCode{
      font-size: 0.4rem;
      line-height: 0.5rem;
      height: 0.5rem;
      width: 2.5rem;
      float: left;
      margin-right: 0.5rem;
      padding: 0.1rem 0.2rem;
      margin-top: 0.1rem;
      border-radius: 0.15rem;
      margin-top: 0.3rem;
    }
    .personalErCode{
      position: fixed;
      height: 100vh;
      width: 100vw;
      // margin: 0 0.5rem;
      background: #FDFBF7;;
      top: 0;
      left: 0;
      // padding-top: 1.3rem;
      z-index: 222;
      .erCodeWarp{
        padding-bottom: 1.5rem;
        border-radius: 0;
        .baseLine{
          margin-top: 0.5rem;
        }
        .name{
          font-size: 0.45rem;
          margin: 0.52rem 0
        }
        .buttonConfirm{
          height: 1.17rem;
          width: 4.16rem;
          border-radius: 0.58rem;
          line-height: 1.17rem;
          font-size: 0.42rem;
          letter-spacing: 0.1em;
        }
      }
      .codeBack{
        position: absolute;
        top: 0.4rem;
        left: 0.3rem;
        font-size: 0.4rem;
        border: 1px solid #00000082;
        border-radius: 0.1rem;
        padding: 0.06rem 0.2rem;
      }
      #qrcode{
        width: 5.2rem;
        height: 5.2rem;
        padding: 0.52rem;
        margin: 0.5rem auto;
        margin-bottom: 1rem;
        background: #fff;
        border-radius: 0.26rem;
      }
    }
    // mobile
    &.reSuccess_mobile{
      // background: url('../../assets/ticket/ordersBg.png') 0 0/cover repeat;
      padding-bottom: 2rem;
      min-height: calc(100vh - 3.8rem);
      margin-bottom: 0;
      .reSuccessTopWarp{
        padding-top: 0.1rem;
        background: #fff;
        border-radius: 0 0 0.52rem 0.52rem;
        padding-bottom: 0.3rem;
        box-shadow: 0px 0.2rem 0.364rem rgba(0, 0, 0, 0.04);
        margin-top: -0.3rem;
      }
      .reSuccessWbs{
        height: 2.34rem;
        margin: 0.5rem;
        &:before{
          background-color: #ffffff99;
          -webkit-mask: url('~@/assets/ticket/sunShine.svg') 0 0/100% 100% no-repeat;
          mask: url('~@/assets/ticket/sunShine.svg') 0 0/100% 100% no-repeat;
          width: 100%;
          height: 100%;
          content: '';
          display: inline-block;
          position: absolute;
          top: 0;
          left: 0;
        }
        .text{
          top: 0.39rem;
          color: #F4E7CF;
          font-size: 0.52rem;
          letter-spacing: 0.1em;
          width: 100%;
          left: 0;
          .resText{
            color: #fff;
            letter-spacing: 0.02em;
            margin-top: 0.3rem;
          }
        }
        .textLine{
          top: 0.85rem;
        }
      }
      .itemCard{
        background: #F9F8F6;
        border-radius: 0.26rem;
        .reTime{
          color: #33333366;
          span{
            color: #333333;
          }
        }
      }
      .personalCard{
        border: unset;
        background: #fff;
        box-shadow: 0px 0.1rem 0.26rem 0px rgba(0, 0, 0, 0.08);
      }
    }
    // pc
    .pcContent{
      #qrcode2{
        width: 100px;
        height: 100px;
        margin: auto;
        margin-bottom: 0;
        background: #fff;
        padding: 10px;
        border-radius: 8px;
      }
      .baseLine2{
        margin: 0.2rem;
        margin-left: 0.8rem;
      }
      .erCodeText{
        font-size: 16px;
        margin-top: 0.02rem;
        text-align: center;
        color: #333333;
      }
      .textLine{
        top: 90px !important;
      }
      img{
        width: 100%;
        padding: 0;
      }
      .button3{
        margin: auto;
      }
      .reTime{
        font-family: FZDBSJW;
      }
      .pcItemCard{
        margin-top: 30px;
        img{
          width: 1.2rem;
          padding-top: 0.2rem;
        }
        .reTime{
          font-size: 24px;
          margin-left: 200px;
          span{
            font-size: 24px;
            margin-left: 36px;
          }
        }
        .pc{
          padding: 40px 0;
          background-color: #fff;
          border-radius: 20px;
          box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.04);
          .line3{
            margin: 0 80px;
            margin-left: 200px;
            display: flex;
            position: relative;
            align-items: flex-start;
            justify-content: space-between;
          }
        }
      }
    }
  }
</style>
<style type="text/css" lang="scss">
  .reSuccess{
    .reSuccessWbs{
      text-align: left;
      margin: 0.5rem 0.5rem 0.8rem 0.5rem;
      width: 9rem;
      height: 3.5rem;
      border-radius: 0.2rem;
      position: relative;
      img{
        width: 3.2rem;
        height: 3.2rem;
        position: absolute;
        top: 0.5rem;
        left: 0.8rem;
        object-fit: cover;
      }
      .text{
        text-align: center;
        position: absolute;
        font-size: 0.5rem;
        // font-family: SSBold;
        left: 1.2rem;
        top: 1.3rem;
        div:nth-child(1){
          margin-bottom: 0.2rem;
        }
        .resText{
          font-size: 0.35rem;
        }
      }
    }
    .leftName{
      writing-mode: horizontal-tb;
      align-items: center;
    }
    .childLeft{
      height: 2.6rem;
    }
    &.reSuccess_mobile{
      .personalCard{
        border-radius: 0.26rem;
        .left{
          display: none;
        }
        .right{
          .rightContent{
            width: 8.22rem;
            position: relative;
            padding: 0.19rem 0.19rem 0.19rem 0.78rem;
            .cardIndex{
              position: absolute;
              width: 0.65rem;
              height: 0.65rem;
              border-radius: 0.26rem 0 0.26rem 0;
              left: 0;
              top: -0.2rem;
              font-size: 0.39rem;
              line-height: 0.65rem;
              color: #fff;
            }
            .detail{
              line-height: 0.72rem;
              .title{
                color: #33333366;
                margin-right: 0.3rem;
                width: 1.9rem;
                span{
                  margin-left: 0.78rem;
                }
              }
            }
            .showErCode{
              position: absolute;
              height: auto;
              padding: 0.08rem 0.13rem !important;
              border-radius: 0.78rem;
              width: auto;
              height: 2rem;
              top: 50%;
              right: 0.8rem;
              margin: 0;
              margin-top: -1.1rem;
              writing-mode: vertical-lr;
              padding: 0;
              line-height: 0.36rem;
              font-size: 0.34rem;
              text-align: center;
              letter-spacing: 0.021rem;
              &:after{
                position: absolute;
                height: 90%;
                width: 0.013rem;
                background: #3333331a;
                content: '';
                display: inline-block;
                top: 5%;
                right: 1.25rem;
              }
            }
          }
        }
      }
    }
    .pcContent{
      .reSuccessWbs{
        width: 100%;
        height: 220px;
        border-radius: 20px;
        line-height: 43px;
        margin: 0;
        position: relative;
        background: url('../../assets/ticket/re_successBg.png') 0 0/100% 100% no-repeat;
        text-align: center;
        // background: url('../../assets/ticket/success_bg.png') 0 0/100% 100% no-repeat;
        img{
          width:200px;
          height: 220px;
        }
        .left{
          position:absolute;
          left: 0;
          top: 0;
          width:320px;
          height: 220px;
        }
        .right{
          position:absolute !important;
          right: 0 !important;
          top: 0 !important;
          width:320px;
          height: 220px;
          left: auto;
        }
        .text{
          top: 55px;
          left: 400px;
          font-size: 36px;
          letter-spacing: 3.6px;
          font-family: FZDBSJW;
          width: 400px;
          &.successText{
            letter-spacing: unset;
            font-size: 26px;
          }
          div:nth-child(1){
            margin-bottom: 5px;
          }
          .resText{
            margin-top: 15px;
            font-size: 18px;
            letter-spacing: 1.8px;
            line-height: 24px;
          }
        }
        .qrcodeWarp{
          position: absolute;
          right: 0;
          top: 30px;
          right: 180px;
        }
      }
      .reTime{
        margin-left: 0.5rem;
      }
      .personalCard{
        margin: 40px 0;
        padding: 20px;
        width: 580px;
        &::after{
        width: 0.05rem;
        }
        .left, .right{
          font-size: 0.1rem;
          overflow: hidden;
        }
        .left{
          padding: 0 20px;
          padding-left: 0;
          width: 80px;
          min-height: 150px;
          max-height: 300px;
          max-width: 100px;
          margin: 20px 0;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-right: 40px;
          &::after{
            width: 0.05rem;
            height: 100%;
            top: 0;
          }
          .leftName{
            font-size: 20px;
            max-width: unset;
            height: auto;
            line-height: 26px;
            display: flex;
            justify-content: center;
            margin: auto;
            -ms-writing-mode: tb-lr;
            writing-mode: vertical-lr;
            letter-spacing: .05rem;
          }
        }
        .right{
          width: 460px;
          padding: unset;
          margin-left: 0;
          .rightContent{
            width: 3rem;
            .detail{
              line-height: 45px;
              font-size: 20px;
              .title{
                margin-right: 30px;
                font-size: 24px;
                width: 100px;
                text-align: left;
              }
              .name{
                font-size: 20px;
              }
            }
          }
        }
      }
    }
  }
</style>

<style type="text/css">
  .reSuccess #qrcode2 img{
    width: 100%;
    height: 100%;
    position: relative;
    left: unset;
    top: 0;
  }
  .reSuccess #qrcode{
    /*overflow: hidden;*/
  }
  .reSuccess #qrcode img{
    width: 5.2rem !important;
    height: 5.2rem !important;
    object-fit: contain;
    margin: auto;
  }
</style>


